import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-rapporto-elaborazione-modal',
    templateUrl: './rapporto-elaborazione-modal.component.html',
    styleUrls: ['./rapporto-elaborazione-modal.component.scss']
})
export class RapportoElaborazioneModalComponent implements OnInit {
    rapporto: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: RapportoData,
        public dialogRef: MatDialogRef<RapportoElaborazioneModalComponent>) {

        this.rapporto = data.rapporto.join('\n');

    }

    ngOnInit() {
    }
}


export interface RapportoData {
    title: string;
    rapporto: string[];
}
